import AnimatedSprite from './src/components/AnimatedSprite';

export default AnimatedSprite;
module.exports = AnimatedSprite;